import { UuidProjectType } from 'core/userContext';
import { ColumnData as CD } from 'ui/tableHeader';

export enum UniqueIdentifierValues {
  email = 'email',
  userId = 'userId',
  emailOrUserId = 'emailOrUserId',
}

export type UserIdConfig = {
  isUuidBased: boolean;
  uuidProjectType: UuidProjectType;
};

export type CreateProjectPayload = {
  name: string;
  timeZone: string;
  isUuidBased: boolean;
  uuidProjectType: UuidProjectType;
  shardCount: number;
};

export type Organziation = {
  isEnabled: boolean;
  id: number;
  name: string;
  [key: string]: any;
};

export type Project = {
  organizationId: number;
  id: number;
  name: string;
  createdAt: number;
  creatorUserId: string;
  isSandbox: boolean;
  extendedProjectSettings: {
    isArchived: boolean;
    [key: string]: any;
  };
  [key: string]: any;
};

export type ProjectsTableColumnData = CD & {
  RowCell: ({ row }: { row: Project }) => React.ReactElement;
};

export type ProjectsActionButtonProps = {
  openArchiveModal: (project: Project) => void;
  openEditModal: (project: Project) => void;
  openUnarchiveModal: (project: Project) => void;
  project: Project;
};

export type ConfigureProjectColumnsProps = {
  organizations: Organziation[];
  openArchiveModal: ProjectsActionButtonProps['openArchiveModal'];
  openEditModal: ProjectsActionButtonProps['openEditModal'];
  openUnarchiveModal: ProjectsActionButtonProps['openUnarchiveModal'];
};

export type ProjectsReducerState = {
  baus: {
    projects: {
      projects: Project[];
      organizations: Organziation[];
      isLoading: boolean;
    };
  };
};
